import { cacheExchange, createClient, fetchExchange } from '@urql/core';
import { persistedExchange } from '@urql/exchange-persisted';

export const createServerClient = () =>
  createClient({
    url: process.env.GQL_GATEWAY || `${process.env.SERVER_HOST}/api/gateway/`,
    exchanges: [cacheExchange, fetchExchange],
  });

// persistedExchange's default hasher silently falls back to '' in bundled server runtimes.
export const sha256 = async (query: string) => {
  const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(query));
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
};

// APQ only behind the gateway (BACKOFFICE_GQL_APQ=true on master/prod). The configcenter
// answers a hash-only request with 400 instead of PersistedQueryNotFound, so the
// BACKOFFICE_HOST fallback must never get hashes.
export const createBackofficeServerClient = ({
  persistedQueries = true,
}: { persistedQueries?: boolean } = {}) => {
  const sendHashes =
    persistedQueries &&
    !!process.env.BACKOFFICE_GQL_GATEWAY &&
    process.env.BACKOFFICE_GQL_APQ === 'true';

  return createClient({
    url: process.env.BACKOFFICE_GQL_GATEWAY || `${process.env.BACKOFFICE_HOST}/api/graphql`,
    exchanges: [
      cacheExchange,
      ...(sendHashes ? [persistedExchange({ generateHash: sha256 })] : []),
      fetchExchange,
    ],
  });
};
